"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_apexcharts_1 = __importDefault(require("react-apexcharts"));
var donutChartConfig_1 = require("./donutChartConfig");
exports.DonutChart = function (props) {
    var thing = react_1.useCallback(props.onShowTooltip, []);
    var sortedData = props.data
        .filter(function (datum) { return datum.value > 0; })
        .sort(function (a, b) { return b.value - a.value; });
    var data = sortedData.map(function (datum) { return datum.value; });
    var labels = sortedData.map(function (datum) { return datum.label; });
    var colours = sortedData.map(function (datum) { return datum.colour; });
    var chart = donutChartConfig_1.createDonutChartConfig({
        id: props.id,
        data: data,
        colours: colours,
        labels: labels,
        tooltipFired: thing,
        sizes: props.sizes,
    });
    return react_1.default.createElement(react_apexcharts_1.default, { type: "donut", options: chart.options, series: chart.series, width: props.width });
};
